import { render, staticRenderFns } from "./FieldInfo.vue?vue&type=template&id=158b6471&scoped=true"
import script from "./FieldInfo.vue?vue&type=script&lang=js"
export * from "./FieldInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b6471",
  null
  
)

export default component.exports